export default "__VITE_ASSET__ad28e794__"